import React from "react";

const ACTIONS = [
  { value: "queue", label: "Save and Queue", className: "bg-amber-600 hover:bg-amber-700" },
  { value: "close", label: "Close Ticket", className: "bg-rose-600 hover:bg-rose-700" },
  { value: "discard", label: "Discard and Start New", className: "bg-slate-700 hover:bg-slate-800" },
];

const ActiveTicketWarningModal = ({
  isOpen,
  activeTicket,
  onClose,
  onAction,
  isSubmitting = false,
}) => {
  if (!isOpen || !activeTicket) {
    return null;
  }

  return (
    <div className="fixed inset-0 z-[120] flex items-center justify-center bg-black/40 px-4">
      <div className="w-full max-w-xl rounded-2xl bg-white shadow-2xl ring-1 ring-slate-200">
        <div className="border-b border-slate-200 px-6 py-4">
          <h3 className="text-lg font-semibold text-slate-900">Active Ticket Detected</h3>
          <p className="mt-1 text-sm text-slate-600">
            Ticket <span className="font-semibold text-slate-900">#{activeTicket.tkt_num}</span> is still active.
          </p>
        </div>

        <div className="space-y-3 px-6 py-5 text-sm text-slate-700">
          <p>What would you like to do with the current ticket before starting a new one?</p>
          <div className="rounded-xl border border-slate-200 bg-slate-50 px-4 py-3">
            <div className="grid grid-cols-1 gap-2 sm:grid-cols-2">
              <div>
                <span className="text-xs uppercase tracking-wide text-slate-500">Member</span>
                <p className="font-medium text-slate-900">{activeTicket.member_name || "-"}</p>
              </div>
              <div>
                <span className="text-xs uppercase tracking-wide text-slate-500">Coverage</span>
                <p className="font-medium text-slate-900">{activeTicket.coverage || "-"}</p>
              </div>
              <div>
                <span className="text-xs uppercase tracking-wide text-slate-500">Source</span>
                <p className="font-medium text-slate-900">{activeTicket.source || "-"}</p>
              </div>
              <div>
                <span className="text-xs uppercase tracking-wide text-slate-500">Last Update</span>
                <p className="font-medium text-slate-900">{activeTicket.datetime_last_update || "-"}</p>
              </div>
            </div>
          </div>
        </div>

        <div className="flex flex-wrap items-center justify-end gap-2 border-t border-slate-200 px-6 py-4">
          <button
            type="button"
            disabled={isSubmitting}
            onClick={onClose}
            className="rounded-lg border border-slate-300 px-3 py-2 text-sm font-medium text-slate-700 hover:bg-slate-100"
          >
            Cancel
          </button>

          {ACTIONS.map((action) => (
            <button
              key={action.value}
              type="button"
              disabled={isSubmitting}
              onClick={() => onAction(action.value)}
              className={`rounded-lg px-3 py-2 text-sm font-semibold text-white ${action.className} disabled:cursor-not-allowed disabled:opacity-70`}
            >
              {isSubmitting ? "Please wait..." : action.label}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ActiveTicketWarningModal;
